import { createSelector } from 'reselect';

const bookingsListSelector = createSelector(
  (state) => state.bookingsList,
  (bookingsList) => bookingsList,
);

export const isLoading = createSelector(
  bookingsListSelector,
  (bookingsList) => bookingsList.isLoading,
);

export const list = createSelector(bookingsListSelector, (bookingsList) => bookingsList.list);

export const error = createSelector(bookingsListSelector, (bookingsList) => bookingsList.error);

export const success = createSelector(bookingsListSelector, (bookingsList) => bookingsList.success);

export const nextPage = createSelector(bookingsListSelector, (reviews) => reviews.nextPage);

export default bookingsListSelector;
